import logo from "../Logo.png";
import styles from "./VideoPage.module.css";
import { Stack } from "@mui/material";
import { ThumbUp, ThumbDown, SentimentVeryDissatisfied } from "@mui/icons-material";
import { Button } from "@mui/material";
import {  useParams } from "react-router-dom";
import { config } from "../App";
import axios from "axios";
import { useEffect, useState } from "react";
import {calcDaysandTime} from "./LandingPageVideo"
import {useSnackbar} from "notistack";

const VideoPage = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const[indivisualVideo,setIndivisualVideo]=useState([]);
  
  const params=useParams();
  const videoId=params._id;
  
  const performVideoCallUnique=async ()=>{
    try{
      const response=await axios.get(`${config.endpoint}/${videoId}`)
      setIndivisualVideo(response.data);
      console.log(response.data);
      
    }catch(err){
      enqueueSnackbar(err.message,{variant:"error"})
    }
  }
  
  useEffect(()=>{
    performVideoCallUnique();
  },[])
  
  
  const ViewsHandler=async ()=>{
    try{
      const response=await axios.patch(`${config.endpoint}/${videoId}/views`,{
        viewCount:"viewCount",
        change:"increase"
      })
    
    }catch(err){
      enqueueSnackbar("Incorrect Id to increase view count",{variant:"error"});

    }
  }

  useEffect(()=>{
    ViewsHandler();
  },[])
      
  const VotesHandler=async (type)=>{
    console.log("entering");
    let votesData={};
    if(type==="upVote"){
      votesData={
        vote:"upVote",
        change:"increase"
      }
    }
      else if(type==="downVote"){
        votesData={
          vote:"downVote",
          change:"decrease"
        }

      }

   try{ 
     const response=await axios.patch(`${config.endpoint}/${videoId}/votes`,votesData, {
      headers:{
        "Content-Type":"application/json"
      }
    })

    enqueueSnackbar("Voted Successfully",{variant:"success"});

  }catch(err){
      if(err.response.status===400){
        enqueueSnackbar("Error occured during voting. Please try again later.",{variant:"error"})
      }
    }
  }
  
  return (
      <>
      {indivisualVideo.length===0 ? <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} mt={30}><SentimentVeryDissatisfied sx={{color:"#D1D5DA",fontSize:"2rem"}} ></SentimentVeryDissatisfied> <p className={styles.notFound}>No video found</p></Stack> :
      <>
      <div className={styles.navigation}>
        <Stack justifyContent="center" >
          <img src={logo} alt="xflix logo" className={styles.logo}></img>
        </Stack>
      </div>
        <div className={styles.container}>
      <div>
        <iframe
          src={`https://www.${indivisualVideo.videoLink}`}
          className={styles.video}
          title={indivisualVideo.title}
        />
        <Stack justifyContent="flex-start" className={styles.features} >
          <p className={styles.title}>{indivisualVideo.title}</p>
          <Stack direction="row" justifyContent="flex-start" spacing={3} mt={2}>
            <p>{indivisualVideo.viewCount}</p>
            <p>{indivisualVideo.genre}</p>
            <p>{calcDaysandTime(indivisualVideo.releaseDate)}</p>
            <div className={styles.lastDiv}>
              <Button className={styles.voteButton} onClick={()=>{
                VotesHandler("upVote")
              }}> 
                <ThumbUp sx={{height:"15px",width:"15px",marginRight:"3px"}}></ThumbUp>
                {indivisualVideo.votes.upVotes}
              </Button>
              <Button className={styles.voteButton} onClick={()=>{
                VotesHandler("downVote");
              }}>
                <ThumbDown sx={{height:"15px",width:"15px",marginRight:"3px"}}></ThumbDown>
                {indivisualVideo.votes.downVotes}
              </Button>
                {/* VotesHandler(indivisualVideo.votes.upVotes,null); */}
            </div>
          </Stack>
        </Stack>
      </div>
      <br></br>
      <hr style={{width:"70rem"}}></hr>
      <br></br>
    </div>
      </>
      
      }
      
    </>
  );
};

export default VideoPage;
